import axios from "axios";
import { toast } from "react-toastify";
import { API_ERROR_500 } from "../../../../../config";
import { getStageScreen, setLoading } from "../../../../../redux";
import { GET_ESIGN_SUCCESS, GET_ESIGN_FAILURE } from "./type";

export const handleSignedKyc = () => {
  const portal_domain = window.sessionStorage.getItem("portal_domain");
  const API_URL = portal_domain
    ? portal_domain.substring(0, portal_domain.length - 1)
    : "";
  const token = window.sessionStorage.getItem("token");
  const headers = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Authorization: `Basic ${token}`,
    },
  };
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const resp = await axios.post(
        `${API_URL}/api/method/kyc_customizations.apis.kyc_verification.api.get_signed_kyc`,
        {},
        headers
      );
      dispatch(getStageScreen());
      dispatch(setLoading(false));
      toast.success(resp?.data?.message);
    } catch (error) {
      const { response } = error;
      if (response?.data?.message) {
        toast.error(response?.data?.message);
      } else {
        toast.error(API_ERROR_500);
      }
      dispatch(setLoading(false));
    }
  };
};

export const checkEsignUrl = (successCb, failedCb) => {
  const portal_domain = window.sessionStorage.getItem("portal_domain");
  const API_URL = portal_domain
    ? portal_domain.substring(0, portal_domain.length - 1)
    : "";
  const token = window.sessionStorage.getItem("token");
  const headers = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Authorization: `Basic ${token}`,
    },
  };
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const resp = await axios.post(
        `${API_URL}/api/method/kyc_customizations.apis.kyc_verification.api.get_esign_redirect_url`,
        {},
        headers
      );
      console.log("resp", resp.data?.data);
      if (resp.data?.data?.redirect_url_kyc && resp.data?.data?.redirect_url_kyc_2) {
        successCb();
        dispatch({ type: GET_ESIGN_SUCCESS, payload: resp.data?.data });
        dispatch(setLoading(false));
      } else {
        dispatch({ type: GET_ESIGN_FAILURE, payload: null });
        failedCb();
      }
    } catch (error) {
      dispatch({ type: GET_ESIGN_FAILURE, payload: null });
      dispatch(setLoading(false));
    }
  };
};


export const updateEsignStatus = (payload) => {
  const portal_domain = window.sessionStorage.getItem("portal_domain");
  const API_URL = portal_domain
    ? portal_domain.substring(0, portal_domain.length - 1)
    : "";
  const token = window.sessionStorage.getItem("token");
  const headers = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Authorization: `Basic ${token}`,
    },
  };

  // Convert payload to URLSearchParams for form data
  const formData = new URLSearchParams();
  Object.keys(payload).forEach(key => {
      formData.append(key, payload[key]);
  });

  return async (dispatch) => {
      try {
          dispatch(setLoading(true));
          const resp = await axios.post(
              `${API_URL}/api/method/kyc_customizations.esign.update_esign_done.endpoint`,
              formData,
              headers
          );
          dispatch(getStageScreen())
          // Handle response here
          dispatch(setLoading(false));
      } catch (error) {
          // Error handling
          dispatch(setLoading(false));
      }
  };
};
